'use strict';

const {loadCollections, collections} = require('./model.collections');
const modelKeys = require('./model.keys');
const globalConfig = require('../config/config');
const productRules = require('../utils/product.rules');
const selectionUtils = require('../utils/selection.utils');
const shoppingCart = require('od-modules/cart/cart');
const {additionalProductsCatalog} = require('od-modules/track_events/track.frontevents.additional.products');

const isAccommodationPostBooking = () => Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking')) || false;
const isDynpack = () => Odigeo.Utils.isRequestApp('dp');
const isUpsell = () => Odigeo.Utils.isRequestApp('upsell');
const hasAccommodation = () => isDynpack() || isUpsell();
const CANXSELF = 'CANXSELF';

module.exports = {
    selectedProducts: [],
    connect: true,
    selectors: [
        'hasTrains',
        'productName',
        'primeMemberSelected',
        'userStatus',
    ],
    defaults: {
        userStatus: null,
    },
    initialize() {
        this.storeTotalTicketPrice();
    },
    onStoreChange: function() {
        if (this.load) {
            this.load();
        }
    },

    loadData(callback = () => {}) {
        loadCollections(() => {
            this.setPayWithGuaranteeTrackingConditionsData();
            callback(this.getData());
        });
    },

    storeTotalTicketPrice(price = collections.cart.calculateTotalPrice()) {
        this.set('totalTicketPrice', price);
    },

    setPayWithGuaranteeTrackingConditionsData({link} = {}) {
        const cancellationGuarantee = this.getCancellationGuarantee();

        Odigeo.trigger('pay-with-guarantee:setPayWithGuaranteeTrackingConditionsData', {
            policy: cancellationGuarantee.policy,
            pdfUrl: cancellationGuarantee.conditionsUrlExtended,
            link,
        });
    },

    shouldDisplayPrimeTC() {
        return this.get('primeMemberSelected') && this.get('primeMemberSelected').isSubscriptionAdded;
    },

    getData() {
        const gdprKey = `bookingGDPR_${hasAccommodation() ? 'DP': 'FLIGHTS'}`;
        return {
            prices: this.getPrices(),
            cancellationGuaranteeData: this.getCancellationGuarantee(),
            isFreeCancellation: this.isFreeCancellation(),
            freeCancellationLimitHoursApart: this.getFreeCancellationLimitHoursApart(),
            isDP: isDynpack(),
            isVoucher: this.isVoucherABTestEnabled(),
            hasAccommodation: hasAccommodation(),
            gdprKey,
            isRepricing: this.isRepricing(),
            isImplicitAcceptance: collections.websiteConfig.isImplicitAcceptance(),
            isAccommodationPostBooking: isAccommodationPostBooking(),
            payWithGuaranteeReorderTestPartition: this.isPayWithGuaranteeReorderTestPartition(),
            shouldDisplayPrimeTC: this.shouldDisplayPrimeTC(),
            existsEvolviCarrier: this.get('existsEvolviCarrier'),
            existsDeutscheBahnCarrier: this.get('existsDeutscheBahnCarrier'),
        };
    },

    getPrices() {
        return {
            guaranteePrice: this.getGuaranteePrice(),
            totalGuaranteePrice: this.getTotalGuaranteePrice(),
            totalWithoutGuarantee: this.getTicketPrice(),
            totalWithGuarantee: this.getTicketPrice() + this.getTotalGuaranteePrice(),
            serviceOptions: this.getServiceOptionsPremiumPrice(),
            repricing: this.getRepricing(),
        };
    },

    getGuaranteePrice() {
        return this.getCancellationGuarantee().segmentPassengerPrice;
    },

    getTotalGuaranteePrice() {
        return this.getCancellationGuarantee().totalPrice;
    },

    getTicketPrice() {
        return this.isRepricing() ? this.getNewTicketPriceAfterRepricing() : this.get('totalTicketPrice');
    },

    getProductId() {
        return this.getProductIdForPayWithGuarantee();
    },

    getServiceOptionsPremiumPrice() {
        return collections.serviceOptions.getServicePackPremiumPrice();
    },

    getRepricing() {
        return {
            totalWithoutGuarantee: this.getOldTicketPriceAfterRepricing(),
            totalWithGuarantee: this.getOldTicketPriceAfterRepricing() + this.getTotalGuaranteePrice(),
        };
    },

    getNewTicketPriceAfterRepricing() {
        return this.getRepricingData().newPrice || 0;
    },

    getOldTicketPriceAfterRepricing() {
        return this.getRepricingData().oldPrice || 0;
    },

    getProductIdForPayWithGuarantee() {
        return this.isPayWithGuaranteeEnabled() ? this.getPayWithGuaranteeInsuranceId() : null;
    },

    getCancellationGuarantee() {
        const policy = this.getPayWithGuaranteeInsuranceId();
        return {
            ...collections.insurances.getInsuranceByPolicy(policy),
            label: additionalProductsCatalog.PAYMENT_BUTTON.label(policy),
        };
    },

    getPayWithGuaranteeInsuranceId() {
        return Odigeo.AB.isImproveDoublePaymentButton
            ? productRules.getGuaranteeIdBasedOnSessionSelection()
            : productRules.getPayWithGuaranteeInsuranceId();
    },

    insuranceForPayWithGuaranteeExists() {
        return !Odigeo._.isEmpty(productRules.getPayWithGuaranteeInsuranceId());
    },

    getTotalPrice() {
        return parseFloat(this.get('totalPrice')) || 0;
    },

    preProcessKeysByPolicyAndApplicationFlow(keys) {
        const productId = this.getProductId();
        const isVoucherCanx = productId === CANXSELF ? globalConfig.ab.voucherCanx.isEnabled(this.getABs()) : false;
        let keysToProcess = keys;

        if (isVoucherCanx) {
            keysToProcess = modelKeys.replaceVoucherKeys(keysToProcess);
        }

        return modelKeys.preProcessKeysByPolicyAndApplicationFlow(this.getProductId(), keysToProcess);
    },

    isFreeCancellation() {
        return !collections.websiteConfig.isFreeCancellationHeader()
            && collections.websiteConfig.isFreeCancellationEnabled()
            && collections.flightDetails.getFreeCancellationLimitHoursApart() > 0;
    },

    getFreeCancellationLimitHoursApart() {
        return this.isFreeCancellation() ? collections.flightDetails.getFreeCancellationLimitHoursApart() : 0;
    },

    getABs() {
        return collections.websiteConfig.getAB();
    },

    isVoucherABTestEnabled() {
        return globalConfig.ab.voucherCanx.isEnabled((this.getABs()));
    },

    isPayWithGuaranteeReorderTestPartition() {
        return globalConfig.ab.payWithGuarantee.isReorderABEnabled(this.getABs());
    },

    isPayWithGuaranteeEnabled() {
        return this.insuranceForPayWithGuaranteeExists()
            && !this.isAnyProductIncompatible()
            && !isAccommodationPostBooking()
            && !this.isFlexibilityMembershipAdded();
    },

    isFlexibilityMembershipAdded() {
        const primeMemberSelected = this.get('primeMemberSelected');
        return this.isMembershipFlexibilityAB() && primeMemberSelected && primeMemberSelected.isSubscriptionAdded;
    },

    isMembershipFlexibilityAB() {
        return Odigeo.Membership.isMembershipFlexibilityM || Odigeo.Membership.isMembershipFlexibilityD;
    },

    isAnyInsurancesInCartOrInSession() {
        return globalConfig.isAnyInsurancesInCartOrInSession(this);
    },

    isAnyInsurancesInCart() {
        return this.isAnyProductIncompatibleWithCancellationInCart();
    },

    isAnyProductIncompatible() {
        return Odigeo.AB.isImproveDoublePaymentButton
            ? this.isAnyProductIncompatibleWithCancellationOrFlexInCart()
            : this.isAnyInsurancesInCartOrInSession();
    },

    isAnyProductIncompatibleWithCancellationInSession() {
        return this.isAnyProductIncompatibleWithCancellationInCart();
    },

    isAnyProductIncompatibleWithCancellationOrFlexInCart() {
        return !selectionUtils.getGuaranteeIdBasedOnSessionSelection();
    },

    isAnyProductIncompatibleWithCancellationInCart() {
        return this.getInsurancesExcludingAdditions();
    },

    getInsurancesExcludingAdditions() {
        return shoppingCart.take.insurances(({type} = {}) => {
            const {policy} = collections.insurances.getInsuranceByPolicy(type) || {};
            return type === policy;
        }).length > 0;
    },

    isAnyServicePackInCart() {
        return shoppingCart.take.serviceOptions().length > 0;
    },

    getSelectedProducts() {
        return this.get('selectedProducts') || {};
    },

    updateSelectedProducts(product = {}) {
        this.set('selectedProducts', {...this.getSelectedProducts(), ...product});
    },

    storeProductSelection({id, pbdType, selected}) {
        this.updateSelectedProducts({
            [id]: {
                policy: id,
                pbdType,
                added: selected,
            },
        });
    },

    setRepricing(data = {}) {
        this.set('isRepricing', true);
        this.set('repricing', data);
    },

    isRepricing() {
        return this.get('isRepricing') || false;
    },

    getRepricingData() {
        return this.get('repricing') || {};
    },
};
